export * from 'server/models/PSixServiceVessel';


// WEBPACK FOOTER //
// ./data/models/PSixServiceVessel.ts